import React from 'react'
import PropTypes from 'prop-types'

import './style.scss'


export default function RadioButton(props) {
  const id= props.id || `id_${props.name}`
  return (
    <div className="RadioButton">
      <div className="RadioButton__wrapper">
        <div className="RadioButton__wrapper__radio">
          <input type="radio" id={id} {...props} />
        </div>
        <div className="RadioButton__wrapper__label">
          <label htmlFor={id}>{props.label}</label>
        </div>
      </div>
    </div>
  )
}

RadioButton.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/RadioButton/index.js